<template>
  <Container>
    <v-flex justify-start>
      <v-card class="elevation-12">
        <v-toolbar dark tabs>
          <v-btn
            icon
            color="white"
            light
            v-on:click="$router.push('/labyrinth')"
          >
            <v-icon>arrow_back</v-icon>
          </v-btn>
          <v-toolbar-title>{{ labyrinthList.category }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn color="green" @click="showModalCreate()">
            <v-icon>add</v-icon>New Labyrinth Game
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-data-table
            v-if="!isLoadLabyrinth"
            :items="labyrinthList.labyrinth_games"
            :headers="headers"
            :search="search"
            :rows-per-page-items="[20, 50, 100]"
          >
            <template v-slot:items="props">
              <td>
                <v-layout justify-center>{{ props.index + 1 }}</v-layout>
              </td>
              <td>
                <v-layout justify-center>{{ props.item.title }}</v-layout>
              </td>
              <td>
                <v-layout justify-center>{{
                  props.item.game_round.length
                }}</v-layout>
              </td>
              <td>
                <v-layout justify-center>{{ props.item.size_area }}</v-layout>
              </td>
              <td>
                <v-layout justify-center> {{ props.item.updated_at }}</v-layout>
              </td>
              <td>
                <v-layout justify-end>
                  <v-btn
                    icon
                    color="black"
                    @click="onClickAddHomePage(props.item._id)"
                  >
                    <v-icon>home</v-icon>
                  </v-btn>
                  <v-btn
                    icon
                    color="black"
                    v-on:click="onClickEdit(props.item._id)"
                  >
                    <v-icon color="white">edit</v-icon>
                  </v-btn>
                  <v-btn
                    icon
                    color="red"
                    v-on:click="onClickDelete(props.item._id)"
                  >
                    <v-icon color="white">delete</v-icon>
                  </v-btn>
                </v-layout>
              </td>
            </template>
          </v-data-table>
          <v-progress-linear v-else :indeterminate="true"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-flex>
    <ModalCreateUpdate
      :isOpen="isShowModal"
      :isCreate="isCreate"
      @close="isShowModal = false"
    ></ModalCreateUpdate>
    <HomeDataAssign
      :isOpen="isAddHomepage"
      :gameData="selectedLabyrinth"
      :type="constantHomePage.GameType.PgGame"
      :typePgGame="constantHomePage.typePgGame.Labyrinth"
      @close="isAddHomepage = false"
    ></HomeDataAssign>
  </Container>
</template>

<!-- eslint-disable prettier/prettier -->
<script>
import { mapActions, mapState } from 'vuex';
import Container from '../../../components/Container';
import { ModalCreateUpdate } from './components';
import rules from '../../../utils/ruleValidate';
import swal from 'sweetalert2';
import constants from './components/constants';
import HomeDataAssign from '../../HomePage/components/HomeDataAssign.vue';
import constantHomePage from '../../HomePage/constant';

export default {
  name: 'Labyrinth',
  components: {
    Container,
    ModalCreateUpdate,
    HomeDataAssign,
  },
  data() {
    return {
      constants,
      constantHomePage,
      search: '',
      headers: [
        {
          text: 'No.',
          value: 'no.',
          align: 'center',
          sortable: false,
        },
        {
          text: 'Title',
          value: 'title',
          align: 'center',
          sortable: false,
        },
        {
          text: 'Game Round',
          value: 'round',
          align: 'center',
          sortable: false,
        },
        {
          text: 'Size Area',
          value: 'round',
          align: 'center',
          sortable: false,
        },
        {
          text: 'Updated Date',
          value: 'updated_at',
          align: 'center',
          sortable: false,
        },
      ],
      isCreate: false,
      isShowModal: false,
      rules,
      isAddHomepage: false,
    };
  },
  async mounted() {
    const { id, game_list_id, category_id, sub_id } = this.$route.query;
    if (id) {
      await this.fetchLabyrinthList({ id });
      this.onClickEdit(id);
    } else if (game_list_id) {
      await this.fetchLabyrinthList({
        game_list_id,
      });
    } else if (category_id && sub_id) {
      await this.fetchLabyrinthList({
        category_id,
      });
      this.onClickEdit(sub_id);
    }
  },
  computed: {
    ...mapState({
      labyrinthGameStore: state => state.labyrinth,
      labyrinthList: state => state.labyrinth.labyrinthList,
      selectedLabyrinth: state => state.labyrinth.selectedLabyrinth,
      isLoadLabyrinth: state => state.labyrinth.isLoadLabyrinth,
      defaultCreate: state => state.labyrinth.defaultCreate,
    }),
  },
  methods: {
    ...mapActions('labyrinth', [
      'fetchLabyrinthList',
      'deleteLabyrinth',
      'setStateByKey',
    ]),
    setSelectedLabyrinth(id) {
      const [selectedData] = this.labyrinthList.labyrinth_games.filter(
        ({ _id }) => _id == id,
      );
      if (selectedData) {
        this.setStateByKey({
          statekey: 'selectedLabyrinth',
          value: selectedData,
        });
      }
    },
    onClickAddHomePage(id) {
      this.setSelectedLabyrinth(id);
      this.isAddHomepage = true;
    },
    onClickEdit(id) {
      this.setSelectedLabyrinth(id);
      this.setStateByKey({
        statekey: 'updateLabyrinth',
        key: 'id',
        value: id,
      });
      this.isShowModal = true;
      this.isCreate = false;
    },
    onClickDelete(id) {
      swal
        .fire({
          titleText: 'Are you sure to delete?',
          type: 'warning',
          showCancelButton: true,
        })
        .then(result => {
          if (result.value) {
            this.deleteLabyrinth(id);
          }
        });
    },
    showModalCreate() {
      this.isShowModal = true;
      this.isCreate = true;
      this.setStateByKey({
        statekey: 'createLabyrinth',
        value: this.defaultCreate,
      });
    },
  },
};
</script>

<style scoped>
.image_thumbnail {
  height: 90px;
  width: 90px;
  margin-top: 15px;
}
.content_img {
  height: 90px;
  width: 90px;
  border-radius: 8px;
}
</style>
